<template>
  <div>
    <div v-show="visable" class="zdgllb">
      <div class="headergl">
        <div class="headerglinside">
          <el-form
            ref="searchForm"
            :model="searchForm"
            class="demo-form-inline"
            style="display: flex; height: 39px"
            label-width="0px"
            label-position="left"
          >
            <el-form-item label="" prop="dictName">
              <el-input
                v-model="searchForm.dictName"
                style="min-width: 140px"
                placeholder="字典名称"
              />
            </el-form-item>
            <el-form-item prop="dictType">
              <el-input
                v-model="searchForm.dictType"
                style="min-width: 140px"
                placeholder="字典类型"
              />
            </el-form-item>
            <el-form-item prop="status">
              <el-select
                v-model="searchForm.status"
                style="min-width: 140px"
                placeholder="状态"
                clearable
              >
                <el-option
                  v-for="item in [
                    { value: 0, label: '正常' },
                    { value: 1, label: '停用' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="beginTime">
              <el-date-picker
                v-model="searchForm.beginTime"
                type="date"
                style="width: 140px"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item
              label="-"
              label-width="30px"
              prop="endTime"
              style="width: 100%"
            >
              <el-date-picker
                v-model="searchForm.endTime"
                type="date"
                style="width: 140px"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item label-width="0px" style="width: 100%">
              <div style="display: flex">
                <el-button
                  type="primary"
                  style="
                    background: #4170ff;
                    border-radius: 20px;
                    border-color: #4170ff;
                  "
                  icon="el-icon-search"
                  @click="search"
                >搜索</el-button>
                <el-button
                  icon="el-icon-refresh-left"
                  round
                  @click="reset"
                >重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tableGMZ">
        <div class="tableinside">
          <div class="addmessheader">
            <el-button
              type="primary"
              icon="el-icon-plus"
              class="addmess"
              size="mini"
              style="background: #4285c7; border-color: #4285c7; color: #fff"
              @click="addMes"
            >新增</el-button>
            <!-- <el-button
              icon="el-icon-edit-outline"
              class="addmessedit"
              size="mini"
              style="background: #87d8c3; border-color: #87d8c3; color: #fff"
              >修改</el-button
            > -->
            <!-- <el-button
              icon="el-icon-close"
              size="mini"
              class="addmessedit"
              style="background: #e99ea6; border-color: #e99ea6; color: #fff"
              >删除</el-button
            > -->
            <el-button
              icon="el-icon-refresh"
              size="mini"
              style="background: #dd5766; border-color: #dd5766; color: #fff"
              @click="refreshDict"
            >清理缓存</el-button>
          </div>

          <el-table
            ref="gmsqTable"
            :data="tableData"
            style="width: 100%"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              label="字典主键"
              align="center"
              prop="dictId"
            />
            <el-table-column
              label="字典名称"
              show-overflow-tooltip
              align="center"
              prop="dictName"
            />
            <el-table-column label="字典类型" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.dictType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.status === '0' ? 'success' : 'warning'"
                  disable-transitions
                >{{ scope.row.statusStr }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="备注"
              show-overflow-tooltip
              align="left"
              prop="remark"
            />

            <el-table-column
              label="创建时间"
              align="center"
              prop="cjsj"
            />

            <el-table-column label="操作" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit-outline"
                  size="mini"
                  style="
                    background: #4183c6;
                    border-color: #4183c6;
                    color: #fff;
                  "
                  @click="handleEdit(scope.row)"
                >编辑</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-notebook-2"
                  style="
                    background: #61c7c9;
                    border-color: #61c7c9;
                    color: #fff;
                  "
                  @click="handleSelect(scope.row)"
                >列表</el-button>

                <el-button
                  size="mini"
                  icon="el-icon-close"
                  style="
                    background: #dd5766;
                    border-color: #dd5766;
                    color: #fff;
                  "
                  @click="handleDelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>

    <!-- 字典管理列表 -->
    <zdgllbcz v-show="!visable" :dict-type="submitForm.dictType" />

    <!-- 字典管理编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="submitForm.dictId ? '修改类型' : '新增类型'"
      :visible.sync="dialogFormVisible"
      width="500px"
      custom-class="zhengjian"
      center
      @close="cancleHandle"
    >
      <el-form ref="submitForm" :model="submitForm">
        <el-form-item
          label-width="91px"
          label="字典名称:"
          prop="dictName"
          :rules="[{ required: true, message: '请输入字典名称' }]"
        >
          <el-input
            v-model="submitForm.dictName"
            placeholder="请输入字典名称"
            :disabled="type"
            maxlength="200"
          />
        </el-form-item>
        <el-form-item
          label-width="91px"
          label="字典类型:"
          prop="dictType"
          :rules="[{ required: true, message: '请输入字典类型' }]"
        >
          <el-input
            v-model="submitForm.dictType"
            :disabled="type"
            placeholder="请输入字典类型"
            maxlength="200"
          />
        </el-form-item>
        <el-form-item
          label-width="91px"
          label="状态:"
          prop="status"
          :rules="[{ required: true, message: '请选择状态' }]"
        >
          <el-radio-group v-model="submitForm.status">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="91px" label="备注:" prop="remark">
          <el-input
            v-model="submitForm.remark"
            type="textarea"
            :rows="3"
            resize="none"
            maxlength="200"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="cancleHandle">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          style="background: #4285c7; border-color: #4285c7; color: #fff"
          @click="submitHandle"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDictList, addDict, updateDict, deleteDict, refreshDict } from '@/assets/js/dict.js'
import zdgllbcz from './zdgllbcz.vue'
export default {
  components: {
    zdgllbcz
  },
  data() {
    return {
      loading: false,
      // 搜索条件
      searchForm: {
        dictName: '', //  --字典名称
        dictType: '', //  --字典类型
        status: '', // --状态（0正常 1停用）
        beginTime: '', //  --开始时间
        endTime: '' // --结束时间
      },
      submitForm: {
        dictId: '',
        dictName: '', //  --字典名称
        dictType: '', //  --字典类型
        status: '', // --状态（0正常 1停用）
        remark: '' //  --开始时间
      },
      type: false, // 添加和编辑，可编辑，查看不可编辑
      multipleSelection: [], // 多选选中数据
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      tableData: [], // 表格数据
      total: 0, // 总条数
      visable: true,
      dialogFormVisible: false,
      detailMes: {}, // 编辑或查看每条数据的信息
      options: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.gmsqTable.clearSelection()
        this.$refs.gmsqTable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.gmsqTable.clearSelection()
    },
    refreshDict() {
      refreshDict().then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.$message({
            type: 'success',
            message: '刷新缓存成功'
          })
        }
      })
    },
    // 点击搜索时
    search() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      getDictList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    // 编辑
    handleEdit(row) {
      this.dialogFormVisible = true
      this.submitForm = Object.assign({}, row)
    },
    // 查看列表
    handleSelect(row) {
      this.visable = false
      this.submitForm = Object.assign({}, row)
    },
    // 点击申请按钮
    addMes() {
      this.dialogFormVisible = true
      this.submitForm = {
        dictId: '',
        dictName: '', //  --字典名称
        dictType: '', //  --字典类型
        status: '', // --状态（0正常 1停用）
        remark: '' //  --开始时间
      }
      this.$nextTick(() => {
        this.$refs.submitForm.clearValidate()
      })
    },
    reset() {
      this.$refs['searchForm'].resetFields()
      this.search()
    },
    cancleHandle() {
      // 取消
      this.$refs.submitForm.resetFields()
      this.dialogFormVisible = false
    },
    submitHandle() {
      // 提交
      this.$refs.submitForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let API = addDict
          if (this.submitForm.dictId) {
            API = updateDict
          }
          API(this.submitForm).then(res => {
            this.loading = false
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.cancleHandle()
              this.loadData()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    // 删除行数据
    handleDelete(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteDict(row.dictId).then((res) => {
            if (res.status === 200 && res.data.code === '000000') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.loadData()
            }
          })
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 3) {
        cellStyle = 'color: #84a8d0'
      }
      return cellStyle
    },

    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      //   this.search();
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;
  border: 1px solid #ebeef5;
  border-top: 0;
}
.el-tag--primary {
  border-radius: 14px;
}
.el-tag--success {
  border-radius: 14px;
  background-color: #4eb091;
  color: #fff;
}
//   .el-button--primary {
//     color: #fff;
//     background-color: #4170ff;
//     border-color: #4170ff;
//   }
.zdgllb {
  margin-top: 35px;

  .headergl {
    max-width: 1503px;
    width: 95%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 96px;
    background-color: #fff;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin-bottom: 10px;
    .headerglinside {
      margin: 0 auto;
      width: 90%;
      /deep/ .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
  }

  .tableGMZ {
    max-width: 1503px;
    background-color: #fff;
    width: 95%;
    margin: 0 auto;
    .tableinside {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0 57px;
      /deep/ .el-table {
        z-index: 0;
      }
      /deep/ .el-table .has-gutter tr th {
        background: #f4f4f4;
      }
      .addmessheader {
        background: #f4f4f4;
        color: #fff;
        .addmess {
          margin: 12px 0 12px 8px;
        }
      }
    }
  }
}
</style>
